// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".description[data-v-450e0854] {\n  margin-bottom: 20px;\n}\n[data-v-450e0854] .desc-label {\n  width: 120px;\n}\n[data-v-450e0854] .el-table__body-wrapper {\n  height: 200px;\n}", ""]);
// Exports
module.exports = exports;
